import axios from 'axios';
import HttpClient from './httpClient';

const apiVersion = 'v1';

class TetraController extends HttpClient {
  evaluateScore = async (data, token) => {
    try {
      const response = await this.client.post(
        `/${apiVersion}/evaluateScore`,
        data,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  updateTetraData = async (data, documentId, token) => {
    try {
      const response = await this.client.post(
        `/${apiVersion}/updateTetraData/${documentId}`,
        data,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  getTetraData = async (token, documentId) => {
    try {
      const response = await this.client.get(`/${apiVersion}/getATSDetails`, {
        headers: {
          Authorization: token,
        },
        params: { documentId },
      });
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  getAllJDs = async (token, documentId) => {
    try {
      const response = await this.client.get(`${apiVersion}/getAllJds`, {
        headers: {
          Authorization: token,
        },
        params: { documentId },
      });
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  saveAndExit = async (token, data) => {
    try {
      const response = await this.client.post(`/${apiVersion}/saveJd`, data, {
        headers: {
          Authorization: token,
        },
      });
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  deleteJD = async (token, documentId, jdId) => {
    try {
      const response = await this.client.delete(
        `/${apiVersion}/deleteJd/${documentId}/${jdId}`,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  getLinkedInOptimizerData = async (token, documentId, universityCode) => {
    try {
      const response = await this.client.get(`/${apiVersion}/getLinkedInData`, {
        headers: {
          Authorization: token,
        },
        params: { documentId, universityCode },
      });
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  optimizeLinkedInData = async (data, token) => {
    try {
      const response = await this.client.post(
        `/${apiVersion}/optimizeLinkedInData`,
        data,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  getGeneratedContent = async (token, documentId) => {
    try {
      const response = await this.client.get(
        `/${apiVersion}/getGeneratedContent`,
        {
          headers: {
            Authorization: token,
          },
          params: { documentId },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  generateContent = async (data, token) => {
    try {
      const response = await this.client.post(
        `/${apiVersion}/generateContent`,
        data,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  deleteGeneratedCardData = async ({ token, documentId, sectionKey, id }) => {
    try {
      const response = await this.client.delete(
        `/${apiVersion}/deleteGeneratedData`,
        {
          headers: {
            Authorization: token,
          },
          params: { documentId, sectionKey, id },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  generateQuestions = async (data, token) => {
    try {
      const response = await this.client.post(
        `/${apiVersion}/generateQuestions`,
        data,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  generateAnswer = async (data, token) => {
    try {
      const response = await this.client.post(
        `/${apiVersion}/generateAnswer`,
        data,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  getQnAData = async (token, documentId, universityCode) => {
    try {
      const response = await this.client.get(`/${apiVersion}/getQnAData`, {
        headers: {
          Authorization: token,
        },
        params: { documentId, universityCode },
      });
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  generateJobDescripton = async (token, data) => {
    try {
      const response = await this.client.post(
        `${apiVersion}/generateJobDescription`,
        data,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  aiCareerFinancialsExtractResumeData = async (token, data) => {
    try {
      const response = await this.client.get(
        `/${apiVersion}/ai-career-financials-resume-extract`,
        {
          headers: {
            Authorization: token,
          },
          params: {
            ...data,
          },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  extractAICareerFinancials = async (data, token) => {
    try {
      const response = await this.client.post(
        `/${apiVersion}/extractAICareerFinancials`,
        data,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  reviewOverallInterview = async (token, data) => {
    try {
      const response = await this.client.post(
        `${apiVersion}/reviewOverallInterview`,
        data,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  reviewAllQnA = async (token, data) => {
    try {
      const response = await this.client.post(
        `${apiVersion}/reviewAllQnA`,
        data,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  reviewQnA = async (token, data) => {
    try {
      const response = await this.client.post(`${apiVersion}/reviewQnA`, data, {
        headers: {
          Authorization: token,
        },
      });
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  getInterviewReviewDataById = async (token, documentId) => {
    try {
      const response = await this.client.get(
        `/${apiVersion}/getTranscriptReviewData`,
        {
          headers: {
            Authorization: token,
          },
          params: { documentId },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  generateAiMockInterviewAns = async (token, data) => {
    try {
      const response = await this.client.post(
        `${apiVersion}/generateAiMockInterviewAns`,
        data,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  summarizeResumeAndExtractSkills = async (token, data) => {
    try {
      // Call AI service directly instead of going through Tetra proxy
      const aiServiceUrl =
        process.env.REACT_APP_AI_BACKEND || 'http://localhost:8000';
      const response = await axios.post(
        `${aiServiceUrl}/api/summarize-resume-extract-skills`,
        data,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };
}

export default new TetraController(process.env.REACT_APP_API_TETRA_SERVICE);
